import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  "aria-hidden": "true"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M4.433 19.567V12H2.424v9.576h19.152V12h-2.01v7.567H4.434Z",
      "clip-rule": "evenodd"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M10.971 7.279v8.15h2.057v-8.15l2.675 2.575 1.44-1.425-5.143-5-5.143 5 1.466 1.425 2.648-2.575Z"
    }, null, -1)
  ])))
}
export default { render: render }